import { makeStyles } from '@material-ui/core/styles';

const Style = makeStyles((theme) => ({
  error: {
    color: theme.palette.error.main,
  },
}));

export default Style;
